document.addEventListener('DOMContentLoaded', function () {

  const STORAGE_KEY = 'madLeatherWishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(wishlist) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(wishlist));
  }

  function updateHeartButtons() {
    const wishlist = getWishlist();

    document.querySelectorAll('.ml-card-wishlist').forEach(function (button) {
      const handle = button.dataset.productHandle;

      if (wishlist.includes(handle)) {
        button.classList.add('is-wishlisted');
        button.setAttribute('aria-label', 'Remove from Wishlist');
      } else {
        button.classList.remove('is-wishlisted');
        button.setAttribute('aria-label', 'Add to Wishlist');
      }
    });
  }

  document.addEventListener('click', function (event) {

    const button = event.target.closest('.ml-card-wishlist');

    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const handle = button.dataset.productHandle;

    if (!handle) return;

    let wishlist = getWishlist();

    if (wishlist.includes(handle)) {
      wishlist = wishlist.filter(function (item) {
        return item !== handle;
      });
    } else {
      wishlist.push(handle);
    }

    saveWishlist(wishlist);
    updateHeartButtons();

    // Refresh wishlist page if currently on it
    if (document.querySelector('#mad-wishlist-grid')) {
      renderWishlist();
    }
  });

  async function renderWishlist() {

    const grid = document.querySelector('#mad-wishlist-grid');
    const empty = document.querySelector('#mad-wishlist-empty');

    if (!grid || !empty) return;

    const wishlist = getWishlist();

    grid.innerHTML = '';

    if (!wishlist.length) {
      grid.style.display = 'none';
      empty.style.display = 'block';
      return;
    }

    grid.style.display = 'grid';
    empty.style.display = 'none';

    for (const handle of wishlist) {

      try {

        const response = await fetch(
          '/products/' + handle + '.js'
        );

        if (!response.ok) continue;

        const product = await response.json();

        const image = product.featured_image || '';

        const price = Shopify.formatMoney
          ? Shopify.formatMoney(product.price)
          : (product.price / 100).toFixed(2);

        const card = document.createElement('div');

        card.className = 'mad-wishlist-card';

        card.innerHTML = `
          <div class="mad-wishlist-image">
            <a href="${product.url}">
              <img
                src="${image}"
                alt="${product.title.replace(/"/g, '&quot;')}"
                loading="lazy"
              >
            </a>

            <button
              type="button"
              class="mad-wishlist-remove"
              data-remove-wishlist="${handle}"
              aria-label="Remove from Wishlist"
            >
              ×
            </button>
          </div>

          <div class="mad-wishlist-info">
            <h3>
              <a href="${product.url}">
                ${product.title}
              </a>
            </h3>

            <div class="mad-wishlist-price">
              ${price}
            </div>

            <button
              type="button"
              class="mad-wishlist-add"
              data-wishlist-add-cart="${product.variants[0]?.id || ''}"
            >
              Add to Cart
            </button>
          </div>
        `;

        grid.appendChild(card);

      } catch (error) {
        console.error('Wishlist product error:', error);
      }
    }

    if (!grid.children.length) {
      grid.style.display = 'none';
      empty.style.display = 'block';
    }
  }

  document.addEventListener('click', function (event) {

    const removeButton = event.target.closest(
      '[data-remove-wishlist]'
    );

    if (!removeButton) return;

    const handle = removeButton.dataset.removeWishlist;

    let wishlist = getWishlist();

    wishlist = wishlist.filter(function (item) {
      return item !== handle;
    });

    saveWishlist(wishlist);

    renderWishlist();
    updateHeartButtons();
  });

  document.addEventListener('click', async function (event) {

    const addButton = event.target.closest(
      '[data-wishlist-add-cart]'
    );

    if (!addButton) return;

    const variantId = addButton.dataset.wishlistAddCart;

    if (!variantId) return;

    addButton.disabled = true;
    addButton.textContent = 'Adding...';

    try {

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: 1
            }
          ]
        })
      });

      if (!response.ok) {
        throw new Error('Add to cart failed');
      }

      addButton.textContent = 'Added';

      setTimeout(function () {
        addButton.disabled = false;
        addButton.textContent = 'Add to Cart';
      }, 1500);

    } catch (error) {

      console.error(error);

      addButton.disabled = false;
      addButton.textContent = 'Add to Cart';

    }

  });

  updateHeartButtons();
  renderWishlist();

});